module.exports = "/images/contract-cht-page-2.jpg?165d6d89e76c934862d3b80f2922c171";